import axios from "axios";
import {BASE_PATH} from "../services/api";

export const fetchUserInfo = async () => {
    return axios.get(
        BASE_PATH + "/admin/get-user-info/" + localStorage.getItem("user_id"),
        {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    );
};

export const changePassword = async (formData) => {
    return axios.post(BASE_PATH + "/admin/change-password", formData, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

export const getUsers = async () => {
    return axios.get(
        BASE_PATH + "/admin/get-users/" + localStorage.getItem("user_id"),
        {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    );
};

export const createUser = async (formData) => {
    return axios.post(BASE_PATH + "/admin/create-user", formData, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

export const setUserActive = async (formData) => {
    return axios.post(BASE_PATH + "/admin/set-user-active", formData, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

